
import React, { useState } from "react";
import FarmMan from "../images/farm-man.jpg";
import { Link, useNavigate } from "react-router-dom";
import MainLogo from "../images/agrotrust-logo-transparent.png";
import FarmLogo from "../images/farmdb-logo.png";
import EmertechLogo from "../images/Emertech_Logo.png";
import { useDispatch } from "react-redux";
import { login } from "../redux/actions/auth";
import { clearMessage } from "../redux/actions/message";
import { Formik } from "formik";
import * as Yup from "yup";

function Signin() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };

  return (
    <>
      <div className="h-screen flex">
        <div
          style={{ marginTop: "3rem" }}
          className="flex-1 flex flex-col justify-center px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24"
        >
          <div className="mx-auto w-full max-w-sm lg:w-96">
            <div>
              <div className="flex justify-center">
                <img className="h-12 w-auto" src={MainLogo} alt="Workflow" />
              </div>
              <div className="flex justify-center">
                <img
                  style={{ height: "10rem" }}
                  className=" w-auto"
                  src={FarmLogo}
                  alt="Workflow"
                />
              </div>
              <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
                Sign in to your account
              </h2>
            </div>

            <div className="mt-8">
              <div></div>

              <div className="mt-6">
                <Formik
                  initialValues={{ email: "", password: "" }}
                  onSubmit={(values) => {
                    dispatch(login(values))
                      .then(() => {
                        dispatch(clearMessage());
                        navigate("/", { replace: true });
                      })
                      .catch(() => {});
                  }}
                  validationSchema={Yup.object().shape({
                    email: Yup.string().email().required("Email is required"),
                    password: Yup.string().required("Password is required"),
                  })}
                >
                  {(props) => {
                    const {
                      values,
                      touched,
                      errors,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                    } = props;
                    return (
                      <form onSubmit={handleSubmit} className="space-y-6">
                        <div>
                          <label
                            htmlFor="email"
                            className="block text-sm font-medium text-gray-700"
                          >
                            Email address
                          </label>
                          <div className="mt-1">
                            <input
                              id="email"
                              name="email"
                              type="email"
                              autoComplete="email"
                              value={values.email}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              className={
                                errors.email && touched.email
                                  ? "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-red-500 focus:border-red-500 sm:text-sm"
                                  : "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#008542] focus:border-[#008542] sm:text-sm"
                              }
                            />
                            {errors.email && touched.email && (
                              <div className="text-red-500">{errors.email}</div>
                            )}
                          </div>
                        </div>

                        <div className="space-y-1">
                          <label
                            htmlFor="password"
                            className="block text-sm font-medium text-gray-700"
                          >
                            Password
                          </label>
                          <div className="mt-1 relative">
                            <input
                              id="password"
                              name="password"
                              type={showPassword ? "text" : "password"}
                              autoComplete="current-password"
                              value={values.password}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              className={
                                errors.password && touched.password
                                  ? "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-red-500 focus:border-red-500 sm:text-sm"
                                  : "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#008542] focus:border-[#008542] sm:text-sm"
                              }
                            />
                            <button
                              type="button"
                              onClick={togglePasswordVisibility}
                              className="absolute inset-y-0 right-0 px-3 text-sm text-gray-600 focus:outline-none"
                            >
                              {showPassword ? "Hide" : "Show"}
                            </button>
                            {errors.password && touched.password && (
                              <div className="text-red-500">
                                {errors.password}
                              </div>
                            )}
                          </div>
                        </div>

                        <div>
                          <button
                            type="submit"
                            className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md text-sm font-medium text-white bg-[#00AB55] shadow-lg shadow-green-500/50 hover:bg-[#00AB55]  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                          >
                            Sign in
                          </button>
                        </div>
                      </form>
                    );
                  }}
                </Formik>
              </div>
            </div>
            <div className="text-center text-sm mt-20">
              <h5>Powered by</h5>
              <div className="flex justify-center">
                <a
                  href="https://emertech.io/"
                  target={"_blank"}
                  rel="noreferrer"
                >
                  <img
                    className="h-12 w-auto"
                    src={EmertechLogo}
                    alt="Workflow"
                  />
                </a>
              </div>
            </div>
            {/* <h6 className="text-xs">
              AgroTrust Invento ©2022 Created by Emertech Innovations
            </h6> */}
          </div>
        </div>
        <div className="hidden lg:block relative w-0 flex-1">
          <img
            className="absolute inset-0 h-full w-full object-cover"
            src={FarmMan}
            alt=""
          />
        </div>
      </div>
    </>
  );
}

export default Signin;
